<!-- 了解详情 -->
<template>
  <div class="main-news">
    <div class="html5-div"
         v-if="schoolWord">

      <iframe id="bdIframe"
              :src="schoolWord.paramValue"
              ref="framePage"
              width="100%"
              :style="{height:schoolWord.remark+'px'}"
              frameborder="0"
              border="0"
              scrolling="no"
              title=""></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      html5List: [],
      schoolWord: null
    }
  },
  methods: {
    back() {
      this.$router.replace({ name: 'protalMain' })
    }
  },
  created () {
    this.html5List = this.getStorage('html5List')
    if(this.html5List[5]){
      this.schoolWord = this.html5List[5]
    }
  }
}
</script>

<style lang="scss" scoped>
.main-news {
  overflow: hidden;
  // height: 400px;
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 70px;
}
.news-title {
  font-size: 24px;
  text-align: center;
  height: 600px;
}
.news-title-small {
  margin-top: 30px;
}
.news-content {
  text-align: center;
  margin-top: 19px;
}
.news-img {
  text-align: center;
}
.news-img img {
  width: 1200px;
}
.button {
  margin: 20px auto;
  width: 200px;
  .backButton {
    width: 160px;
    height: 36px;
    font-size: 14px;
  }
}
</style>